export class FatZebraPaymentProviderMapper {
    public static mapGetSettingsForLocation(fatZebraSettings: APIv3.FatZebraSettingsResponse): OLO.DTO.FatZebraSettingsResponse {
        return fatZebraSettings ? {
            DirectPostUrl: fatZebraSettings.DirectPostUrl,
            ReturnPath: fatZebraSettings.ReturnPath,
            Verification: fatZebraSettings.Verification?.toLocaleLowerCase(),
        } : null;
    }
}
